import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LabelComponent } from '../../form/label/label.component';
import { CheckboxComponent } from '../../form/input/checkbox.component';
import { ButtonComponent } from '../../ui/button/button.component';
import { InputFieldComponent } from '../../form/input/input-field.component';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-signin-form',
  imports: [
    CommonModule,
    LabelComponent,
    // CheckboxComponent,
    ButtonComponent,
    InputFieldComponent,
    RouterModule,
    FormsModule,
  ],
  templateUrl: './signin-form.component.html',
  styles: ``
})
export class SigninFormComponent {

  showPassword = false;
  isChecked = false;

  email = '';
  password = '';
  isLoading = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  // onSignIn() { console.log('Email:', this.email); console.log('Password:', this.password); console.log('Remember Me:', this.isChecked); }
  onSignIn() {
    this.errorMessage = '';
    this.isLoading = true;

    const payload = {
      email: this.email,
      password: this.password
    };
    console.log(payload, "Payload")

    this.authService.signIn(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        console.log(response, "response")

        console.log('Login success:', response);

        // Save token
        localStorage.setItem('token', response.data.token);

        // Navigate to dashboard
        this.router.navigate(['/']);
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error?.error?.message || 'Login failed';
        console.error('Login error:', error);
      }
    });
  }
}
